import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";


export const getReporteSemanalSucursal = async ({
  mes = null,
  anio = null,
  semana = null,
} = {}) => {
  const response = await api.get("/reporte-semanal-sucursal", {
    params: {
      mes,
      anio,
      semana,
    },
  });

  return response.data;
};


export const useGetReporteCBOIndex = (filtros = {}) => {
  const { Token } = useUserSuperEmpresa();

  const [ReporteCBOIndex, setReporteCBOIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchReporte = async () => {
    setLoading(true);
    try {
      const data = await getReporteSemanalSucursal(filtros);

      setReporteCBOIndex(data);
    } catch (err) {
      setError(err.response?.data?.message || "Error al obtener reporte");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Token) fetchReporte();
  }, [Token, filtros?.mes, filtros?.anio, filtros?.semana]);

  return {
    ReporteCBOIndex,
    loading,
    error,
    refetch: fetchReporte,
  };
};


export const getTotalMensualPorSucursal = async ({ anio = null, mes = null } = {}) => {
  const response = await api.get("/totalMensualPorSucursal", {
    params: { anio, mes },
  });
   
  return response.data;
};


// 🔹 Hook para usarlo en componentes
export const useGetTotalMensualSucursal = (filtros = {}) => {
  const { Token } = useUserSuperEmpresa();

  const [totalesMensuales, setTotalesMensuales] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTotales = async () => {
    setLoading(true);
    try {
      const data = await getTotalMensualPorSucursal({
        anio: filtros.anio,
        mes: filtros.mes,
      });
      
      setTotalesMensuales(data);
    } catch (err) {
      setError(err.response?.data?.message || "Error al obtener totales mensuales");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Token && filtros.anio && filtros.mes) {
      fetchTotales();
    }
  }, [Token, filtros.anio, filtros.mes]); // 👈 clave

  return {
    totalesMensuales,
    loading,
    error,
    refetch: fetchTotales,
  };
};
